<template>
  <div class="DialogUpdateClient__Component">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">עדכון לקוח</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <div class="DialogUpdateClient__Component__Loading">
          <div v-if="isLoadingData">
            <b-loading :is-full-page="false" v-model="isLoadingData" :can-cancel="false" />
          </div>
          <b-field label="שם חברה">
            <b-input v-model="form.Name"></b-input>
          </b-field>
          <b-field label="ח.פ">
            <b-input v-model="form.IdNumber" disabled></b-input>
          </b-field>
          <b-field label="מייל">
            <b-input v-model="form.Email"></b-input>
          </b-field>
          <b-field v-if="form.IsForeignCitizen" label="עיר">
            <b-input v-model="form.City"></b-input>
          </b-field>
          <b-field v-if="form.IsForeignCitizen" label="רחוב">
            <b-input v-model="form.Street"></b-input>
          </b-field>
          <FieldInlineSelect v-if="!form.IsForeignCitizen" :alert-not-exist="true" :hide-hover="true" label="עיר"
            :clearable="true" :filterable="true" :null-is-value="true" placeholder="הקלד עיר" :options="[]"
            :fetch-options="onSearchCities" @onChange="onChange" :reduce="(item) => item" v-model="form.City" />

          <FieldInlineSelect v-if="!form.IsForeignCitizen" :readOnly="!form.City" :alert-not-exist="true"
            :hide-hover="true" label="רחוב" :clearable="true" :filterable="true" :null-is-value="true"
            placeholder="הקלד רחוב" :options="[]" :fetch-options="onSearchCityAddress" @onChange="onChange"
            :reduce="(item) => item" v-model="form.Street" />

          <b-field label="מספר בית">
            <b-input v-model="form.HouseNumber"></b-input>
          </b-field>
          <b-field label="מיקוד">
            <b-input v-model="form.ZipCode"></b-input>
          </b-field>
          <b-field label="תייר">
            <b-switch class="ltr" v-model="form.IsForeignCitizen">{{
              form.IsForeignCitizen ? "כן" : "לא"
            }}</b-switch>
          </b-field>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button :loading="isLoading" @click="save" label="שמור" type="is-primary" />
        <b-button :disabled="isLoading" label="סגור" @click="$emit('close')" />
      </footer>
    </div>
  </div>
</template>

<script>
import LeasingCompaniesService from "@/services/LeasingCompaniesService";
import FieldInlineSelect from "@/components/Fields/FieldInlineSelect.vue";
import { ToastProgrammatic as Toast } from "buefy";
import DriverService from "../services/DriverService";

export default {
  name: "DialogUpdateClient",
  props: ["clientId", "leasingCompanyId", "onSuccess", "delegate"],
  components: {
    FieldInlineSelect
  },
  created() {
    // Load client data from LeasingCompanies API using leasingCompanyId
    LeasingCompaniesService.getClientWithoutProfile(this.leasingCompanyId, this.clientId).then((r) => {
      this.isLoadingData = false;
      // Use Client data if available, otherwise fallback to Profile
      const clientData = r.data.Client || {};
      const profileData = r.data.Profile || {};
      this.form = {
        Name: clientData.Name || profileData.Name,
        IdNumber: clientData.IdNumber || profileData.IdNumber,
        Email: clientData.Email || profileData.Email,
        City: clientData.City || profileData.City,
        Street: clientData.Street || profileData.Street,
        HouseNumber: clientData.HouseNumber || profileData.HouseNumber,
        ZipCode: clientData.ZipCode || profileData.ZipCode,
        IsForeignCitizen: clientData.IsForeignCitizen || profileData.IsForeignCitizen || false,
      };
    }).catch((error) => {
      console.log("error: ", error);
      this.isLoadingData = false;
      Toast.open({
        type: "is-danger",
        message: "לא היה ניתן לטעון את נתוני הלקוח.",
        duration: 8000,
      });
    });
  },
  data() {
    return {
      isLoading: false,
      isLoadingData: true,
      form: {
        Name: null,
        IdNumber: null,
        Email: null,
        City: null,
        Street: null,
        HouseNumber: null,
        ZipCode: null,
        IsForeignCitizen: false,
      }
    };
  },
  methods: {
    onSearchCities({ search, loading, setData, setValue }) {
      if (search.length >= 3) {
        loading(true);
        return DriverService.searchCity(1, 1000, search)
          .then((r) => {
            if (!r.data.Items.length) {
              setValue({ Value: -1, Text: search });
            } else {
              setData(r.data.Items.map((i) => ({ Value: i.Id, Text: i.Name })));
              this.form.Street = null;
            }
          })
          .finally(() => {
            loading(false);
          });
      }
      return null;
    },
    onSearchCityAddress({ search, loading, setData, setValue }) {
      if (search.length >= 2) {
        loading(true);
        return DriverService.searchCityAddress(this.form.City?.Text || this.form.City, 1, 1000, search)
          .then((r) => {
            if (!r.data.Items.length) {
              setValue({ Value: -1, Text: search });
            } else {
              const items = r.data.Items.map((i) => ({ Value: i.Id, Text: i.Name }));
              items.unshift({ Value: -1, Text: search });
              setData(items);
            }
          })
          .finally(() => {
            loading(false);
          });
      }
      return null;
    },
    onChange() { },
    save() {
      this.isLoading = true;
      // Prepare Client update model
      const updateModel = {
        Name: this.form.Name,
        IsForeignCitizen: this.form.IsForeignCitizen,
        Email: this.form.Email,
        Street: this.form.Street?.Text || this.form.Street || '',
        HouseNumber: this.form.HouseNumber || '',
        City: this.form.City?.Text || this.form.City || '',
        ZipCode: this.form.ZipCode || '',
      };
      // Save Client using LeasingCompaniesService with leasingCompanyId
      LeasingCompaniesService.updateClientWithoutProfile(this.leasingCompanyId, this.clientId, updateModel)
        .then(() => {
          this.$emit("close");
          if (this.onSuccess) this.onSuccess();
          this.$emit('customEvent', this.form);
          if (this.delegate) this.delegate();
          Toast.open({
            type: "is-success",
            message: "הלקוח עודכן בהצלחה!",
            duration: 4000,
          });
        })
        .catch(() => {
          Toast.open({
            type: "is-danger",
            message: "לא היה ניתן לבצע את הפעולה, יש לפנות לתמיכה הטכנית.",
            duration: 8000,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss"></style>
